import {
  FireWeatherEvent,
  FloodWarningEvent,
  FloodWatchEvent,
} from './NWSWatchesAndWarningsLayer.types';

export const REFRESH_INTERVAL_SECONDS = 3600 * 3; // 3 hours

export const MAX_ZOOM_LEVEL = 11;

/** New warnings_and_alerts tile source (WDUI 2.0 map coverage). */
export const NWS_RED_FLAG_WARNING_FILL_COLOR = '#F83A9E';
export const NWS_FIRE_WEATHER_WATCH_FILL_COLOR = '#CC6200';
export const NWS_FIRE_ALERT_FILL_OPACITY_STREET = 0.2;
export const NWS_FIRE_ALERT_FILL_OPACITY_SATELLITE = 0.4;
export const NWS_RED_FLAG_WARNING_STROKE_COLOR_STREET = '#F83FA0';
export const NWS_FIRE_WEATHER_WATCH_STROKE_COLOR_STREET = '#CC6200';
export const NWS_RED_FLAG_WARNING_STROKE_COLOR_SATELLITE = '#940550';
export const NWS_FIRE_WEATHER_WATCH_STROKE_COLOR_SATELLITE = '#663100';
export const WEA_POLYGON_COLOR = '#EC7826';
export const FLOOD_COLOR = '#1262ED'; // Flood warnings
export const FLOOD_WATCH_FILL_COLOR = '#004BCC';
/** Flood fill when polygon is not linked to the selected incident (geo event). */
export const FLOOD_NOT_ASSOCIATED_FILL_COLOR = '#4D72B2';
export const NWS_FLOOD_WARNING_FILL_OPACITY_STREET = 0.5;
export const NWS_FLOOD_WATCH_FILL_OPACITY_STREET = 0.3;
export const NWS_FLOOD_WARNING_FILL_OPACITY_SATELLITE = 0.5;
export const NWS_FLOOD_WATCH_FILL_OPACITY_SATELLITE = 0.4;
export const NWS_FLOOD_WARNING_NOT_ASSOCIATED_FILL_OPACITY_STREET = 0.3;
export const NWS_FLOOD_WATCH_NOT_ASSOCIATED_FILL_OPACITY_STREET = 0.1;
export const NWS_FLOOD_WARNING_NOT_ASSOCIATED_FILL_OPACITY_SATELLITE = 0.3;
export const NWS_FLOOD_WATCH_NOT_ASSOCIATED_FILL_OPACITY_SATELLITE = 0.2;
export const NWS_FLOOD_STROKE_COLOR_STREET = FLOOD_COLOR;
export const NWS_FLOOD_STROKE_COLOR_SATELLITE = '#093176';
export const NWS_FLOOD_NOT_ASSOCIATED_FILL_COLOR_SATELLITE = '#2E4570';

/** Hatch pattern opacity when the alert is linked to the selected geo event. */
export const NWS_ALERT_PATTERN_FILL_OPACITY_ASSOCIATED = 1;
/** Hatch pattern opacity when the alert is not linked to the selected geo event. */
export const NWS_ALERT_PATTERN_FILL_OPACITY_NOT_ASSOCIATED = 0.4;

const LAYER_ID_PREFIX = 'warnings-and-alerts';
export const NWS_ALERT_FILL_LAYER_ID = `${LAYER_ID_PREFIX}-fill-layer`;
export const ALERT_CLICKABLE_LAYER_ID = `${LAYER_ID_PREFIX}-clickable-layer`;
export const STROKE_LAYER_ID = `${LAYER_ID_PREFIX}-stroke-layer`;
export const HIGHLIGHT_STROKE_LAYER_ID = `${LAYER_ID_PREFIX}-highlight-stroke-layer`;
export const SELECTED_FILL_LAYER_ID = `${LAYER_ID_PREFIX}-selected-fill-layer`;
export const FILL_PATTERN_LAYER_ID = `${LAYER_ID_PREFIX}-fill-pattern-layer`;
export const SELECTED_STROKE_LAYER_ID = `${LAYER_ID_PREFIX}-selected-stroke-layer`;
export const SELECTED_ALERT_FILL_LAYER_ID = `${LAYER_ID_PREFIX}-selected-alert-fill-layer`;
export const SELECTED_ALERT_FILL_PATTERN_LAYER_ID = `${LAYER_ID_PREFIX}-selected-alert-fill-pattern-layer`;
export const SELECTED_ALERT_STROKE_LAYER_ID = `${LAYER_ID_PREFIX}-selected-alert-stroke-layer`;

export const WEA_POLYGON_FILL_LAYER_ID = `${LAYER_ID_PREFIX}-wea-polygon-fill-layer`;
export const WEA_POLYGON_STROKE_LAYER_ID = `${LAYER_ID_PREFIX}-wea-polygon-stroke-layer`;
export const WEA_POLYGON_FILL_PATTERN_LAYER_ID = `${LAYER_ID_PREFIX}-wea-polygon-fill-pattern-layer`;

export const FIRE_WEATHER_EVENTS = Object.values(FireWeatherEvent);
export const FLOOD_WARNING_EVENTS = Object.values(FloodWarningEvent);
export const FLOOD_WATCH_EVENTS = Object.values(FloodWatchEvent);

export const NWS_WARNINGS_AND_ALERTS_LAYER_SOURCE = 'warnings_and_alerts';
